import React from 'react';
import { connect } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import { ListGroup, Badge } from "react-bootstrap";
import ExpandableActionControl2 from './ExpandableActionControl2';
import { withRouter } from '../../../../shared/hoc/withRouter';
import { Collapse } from "react-bootstrap";
import MenuItemsHelper from "../../../../store/helpers/MenuItemsHelper";

const perfectScrollbarOptions = {
    wheelSpeed: 2,
    wheelPropagation: false
};

class PendingDraftGroup extends React.Component {




    render() {
        return (
            <PerfectScrollbar
                ref={(ref) => { this._scrollBarRef = ref; }}
                options={perfectScrollbarOptions}
                style={{ maxHeight: "calc(100vh - 100px)", position: "relative" }}>
                <div className="kt-notification">
                    <ListGroup>
                        {
                            this.props.actionsObj.subGroups && this.props.actionsObj.subGroups.map((item, index) => (
                                <ExpandableActionControl2
                                    key={this.props.skey + "-MAG" + index}
                                    skey={this.props.skey + "-MAG" + index}
                                    panelCloseBtnRef={this.props.panelCloseBtnRef}
                                    contractid={this.props.contract.contractid}
                                    isOpen={this.props.isOpen}
                                    onSizeChanged={() => { if (this._scrollBarRef) { this._scrollBarRef.forceUpdate(); } }}
                                    actionsObj={item}
                                    party={this.props.party}
                                    contract={this.props.contract}
                                    contractTemplate={this.props.contractTemplate}
                                />
                            ))
                        }

                    </ListGroup>
                </div>
            </PerfectScrollbar>

        );
    }
}


const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
});



export default withRouter(connect(mapStateToProps)(PendingDraftGroup));